import React from 'react'
import { Link } from 'react-router-dom'

function Risetwo() {
  return (
    <>
        <div className="blog-page">
            <div className="container">
                <div className="row gutter-y-60">
                <div className="col-md-12 col-lg-8">
                    <div className="blog-details">
                    <div className="blog-details__image">
                        <img src="assets/images/blog/blog-d-1-1.jpg" className="img-fluid"  />
                    </div>
                    
                    <ul className="list-unstyled blog-card__meta">
                        <li>
                        <img src="assets/images/blog/blog-a-5.png"  />
                        <div className="blog-card__meta__content">
                            <div className="blog-card__meta__label">Post by</div>
                           
                            <Link to="#">Larry S. Bisson</Link>
                        </div>
                       
                        </li>
                        <li>
                        <div className="blog-card__meta__label">
                            <i className="far fa-calendar-alt" />
                            November
                        </div>
                       
                        <Link to="#">25, 2022</Link>
                        </li>
                        <li>
                        <div className="blog-card__meta__label">
                            <i className="far fa-comments" />
                            Comments
                        </div>
                       
                        <Link to="#">(05)</Link>
                        </li>
                        <li>
                        <Link to="#" className="blog-card__meta__share">
                            <i className="far fa-share-alt" />
                        </Link>
                        </li>
                    </ul>
                    
                    <h3 className="blog-details__title">
                        Rise Design Thin king Problems Meet Image System Optimization New
                        Smashing Book
                    </h3>
                    
                    <div className="blog-details__content">
                        <br />
                        <p>
                        Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                        accusantium doloremque laudantium totam rem aperiam, eaque ipsa
                        quae ab illo inventore veritatis et quasi architecto beatae vitae
                        dicta sunt explicbo. Nemo enim ipsam voluptatem quia voluptas sit
                        aspernatur aut odit aut fugit, sed quia consequuntur magni dolores
                        eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam
                        est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci
                        velit, sed quia non numquam eius modi tempora incidunt ut labore
                        et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima
                        veniam, quis nostrum exercitationem ullam corporis suscipit
                        laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem
                        vel eum iure reprehenderit qui in ea voluptate velit esse quam
                        nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo
                        voluptas nulla pariatur
                        </p>
                        <br />
                        <div className="row gutter-y-30">
                        <div className="col-md-6">
                            <img src="assets/images/blog/blog-d-2-1.jpg"  />
                        </div>

                        <div className="col-md-6">
                            <img src="assets/images/blog/blog-d-2-2.jpg"  />
                        </div>

                        </div>
                       
                        <br />
                        <h3>Story Of Life Insurance</h3>
                        <p>
                        Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit
                        aut fugit, sed quia consequuntur see magni dolores eos qui ratione
                        voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem
                        ipsumy quia dolor sit amet, consectetur, adipisci velit, sed quia
                        non numquam eius modi tempora incidunt ut labore et dolore magnam
                        aliquam quaerat voluptatem.
                        </p>
                        <br />
                        <ul className="list-unstyled blog-details__list">
                        <li>
                            <i className="far fa-check" />
                            Bake Layers Of Accessibility Testing Into Your Process
                        </li>
                        <li>
                            <i className="far fa-check" />
                            Understanding Easing Functions For CSS Animations And
                            Transitions
                        </li>
                        <li>
                            <i className="far fa-check" />
                            Guide To Newly Supported, Modern CSS Pseudo-Class Selectors
                        </li>
                        </ul>
                        
                        <br />
                        <blockquote>
                        Practical Steps To Build Transparency In Your Remote Business Web
                        Development Strategies Within
                        <cite>Deshawn T. Gonzalez</cite>
                        </blockquote>
                        <br />
                        <p>
                        On the other hand, we denounce with righteous indignation and
                        dislike men who beguiled demoralized by the charms of pleasure of
                        the moment, so blinded by desire, that they cannot foresee the
                        pain atrouble that are bound to ensue; and equal blame belongs to
                        those who fail in their duty through weakness of will, which is
                        the same as saying through shrinking from toil and pain.
                        </p>
                    </div>
                  
                    <div className="blog-details__tags">
                        <span>Popular Tags</span>
                        <Link to="#">
                        <span>Insurance</span>
                        </Link>
                        <Link to="#">
                        <span>House</span>
                        </Link>
                        <Link to="#">
                        <span>Medical</span>
                        </Link>
                        <Link to="#">
                        <span>Banking</span>
                        </Link>
                        <Link to="#">
                        <span>Car Insurance</span>
                        </Link>
                    </div>
                   
                    <div className="blog-details__social">
                        <span>Share Post</span>
                        <Link to="#">
                        <i className="fab fa-facebook-f" />
                        </Link>
                        <Link to="#">
                        <i className="fab fa-twitter" />
                        </Link>
                        <Link to="#">
                        <i className="fab fa-linkedin-in" />
                        </Link>
                        <Link to="#">
                        <i className="fab fa-instagram" />
                        </Link>
                    </div>
                  
                    <div className="blog-details__author">
                        <div className="blog-details__author__image">
                        <img src="assets/images/blog/blog-d-a-1.png"  />
                        </div>
                        
                        <div className="blog-details__author__content">
                        <h3 className="blog-details__author__title">
                            William K. McAndrew
                        </h3>
                        
                        <p className="blog-details__author__designation">Author</p>
                        
                        <p className="blog-details__author__text">
                            So blinded by desire that they cannot foresee the pain atrouble
                            that are bound to ensue; and equal blame belongs to those who
                            fail in their duty through weakness of same
                        </p>
                      
                        </div>
                        
                    </div>
                  
                    <ul className="list-unstyled blog-sidebar__post blog-sidebar__post--details">
                        <li>
                        <img src="assets/images/blog/blog-d-p-1.png"  />
                        <div className="blog-sidebar__post__content">
                            <p className="blog-sidebar__post__date">
                            <i className="far fa-calendar-alt" />
                            November 25, 2022
                            </p>
                            <h4 className="blog-sidebar__post__title">
                            <Link to="/blogdetails">
                                Meet Image Optimization Smashing Book Addy
                            </Link>
                            </h4>
                           
                        </div>
                       
                        </li>
                        <li>
                        <img src="assets/images/blog/blog-d-p-2.png"  />
                        <div className="blog-sidebar__post__content">
                            <p className="blog-sidebar__post__date">
                            <i className="far fa-calendar-alt" />
                            November 25, 2022
                            </p>
                            <h4 className="blog-sidebar__post__title">
                            <Link to="/blogdetails">
                                Bake Layers Accessibility Testing Into Process
                            </Link>
                            </h4>
                           
                        </div>
                       
                        </li>
                    </ul>
                
                    <div className="comment-one">
                        <h3 className="comment-one__title">Recent Comments</h3>
                        
                        <ul className="comment-list">
                        <li className="comment">
                            <article className="comment-body">
                            <footer className="comment-meta">
                                <div className="comment-author vcard">
                                <img  src="assets/images/blog/blog-c-1.png" className="avatar " />
                                <b className="fn">
                                    <Link to="#" className="url">
                                    Bobby J. Barker
                                    </Link>
                                </b>
                                <span className="says">says:</span>
                                </div>
                               
                                <div className="comment-metadata">
                                <Link to="#">September 15, 2022</Link>
                                </div>
                                
                            </footer>
                            
                            <div className="comment-content">
                                <p>
                                Quis autem vel eum iure reprehenderit quin ea voluptate
                                velit esse quam nihile molestiae consequatur vel illum qui
                                dolorem eum fugiat quo voluptas nulla pariatur On the
                                other hand we denounce righteous
                                </p>
                            </div>
                           
                            <div className="reply">
                                <a rel="nofollow" className="comment-reply-link" href="#">
                                <span>Reply</span>
                                <i className="far fa-arrow-right" />
                                </a>
                            </div>
                            </article>
                            
                        </li>
                       
                        <li className="comment">
                            <article className="comment-body">
                            <footer className="comment-meta">
                                <div className="comment-author vcard">
                                <img  src="assets/images/blog/blog-c-2.png" className="avatar " />
                                <b className="fn">
                                    <Link to="#" className="url">
                                    Jeffery L. Chatham
                                    </Link>
                                </b>{" "}
                                <span className="says">says:</span>
                                </div>
                               
                                <div className="comment-metadata">
                                <Link to="#">September 15, 2022</Link>
                                </div>
                                
                            </footer>
                            
                            <div className="comment-content">
                                <p>
                                Quis autem vel eum iure reprehenderit quin ea voluptate
                                velit esse quam nihile molestiae consequatur vel illum qui
                                dolorem eum fugiat quo voluptas nulla pariatur On the
                                other hand we denounce righteous
                                </p>
                            </div>
                           
                            <div className="reply">
                                <a rel="nofollow" className="comment-reply-link" href="#">
                                <span>Reply</span>
                                <i className="far fa-arrow-right" />
                                </a>
                            </div>
                            </article>
                            
                        </li>
                       
                        </ul>
                    </div>
                  
                    <div className="comments-form">
                        <h3 className="comments-form__title">Leave a Reply</h3>
                        
                        <form action="inc/sendemail.php" className="contact-form-validated contact-one__form" >
                        <div className="row">
                            <div className="col-md-6">
                            <input type="text" placeholder="Full Name" name="name" />
                            </div>
    
                            <div className="col-md-6">
                            <input type="text" placeholder="Email address" name="email" />
                            </div>
    
                            <div className="col-md-12">
                            <textarea
                                name="message"
                                placeholder="Write comments"
                                defaultValue={""} />
                            </div>
                           
                            <div className="col-md-12">
                            <button
                                type="submit"
                                className="thm-btn thm-btn--three contact-one__btn" >
                                <span>
                                Send Comments
                                <i className="far fa-arrow-right" />
                                </span>
                            </button>
                            </div>
                           
                        </div>
                       
                        </form>
                        <div className="result" />
                       
                    </div>
                    
                    </div>
                    
                </div>
           
                <div className="col-md-12 col-lg-4">
                    <div className="blog-sidebar">
                    <div className="blog-sidebar__widget">
                        <h3 className="blog-sidebar__title">Search</h3>
                       
                        <form action="#" className="blog-sidebar__search">
                        <input type="text" placeholder="Keywords" />
                        <button type="submit">
                            <i className="far fa-search" />
                        </button>
                        </form>
                    </div>
                   
                    <div className="blog-sidebar__widget">
                        <h3 className="blog-sidebar__title">Categorys</h3>
                       
                        <ul className="blog-sidebar__list">
                        <li>
                            <Link to="#">Life Insurance</Link>
                            (05)
                        </li>
                        <li>
                            <Link to="#">Health Insurance</Link>
                            (03)
                        </li>
                        <li>
                            <Link to="#">Study Insurance</Link>
                            (07)
                        </li>
                        <li>
                            <Link to="#">Car Insurance</Link>
                            (04)
                        </li>
                        <li>
                            <Link to="#">Fire Insurance</Link>
                            (08)
                        </li>
                        <li>
                            <Link to="#">Business Insurance</Link>
                            (02)
                        </li>
                        </ul>
                       
                    </div>
                   
                    <div className="blog-sidebar__widget">
                        <h3 className="blog-sidebar__title">Recent News</h3>
                       
                        <ul className="blog-sidebar__post">
                        <li>
                            <img src="assets/images/blog/blog-s-1.png"  />
                            <div className="blog-sidebar__post__content">
                            <p className="blog-sidebar__post__date">
                                <i className="far fa-calendar-alt" />
                                November 25, 2022
                            </p>
                            <h4 className="blog-sidebar__post__title">
                                <Link to="/blogdetails">
                                Meet Image Optimization Smashing Book Addy
                                </Link>
                            </h4>
                           
                            </div>
                           
                        </li>
                        <li>
                            <img src="assets/images/blog/blog-s-2.png"  />
                            <div className="blog-sidebar__post__content">
                            <p className="blog-sidebar__post__date">
                                <i className="far fa-calendar-alt" />
                                November 25, 2022
                            </p>
                            <h4 className="blog-sidebar__post__title">
                                <Link to="/blogdetails">
                                Bake Layers Accessibility Testing Into Process
                                </Link>
                            </h4>
                           
                            </div>
                           
                        </li>
                        <li>
                            <img src="assets/images/blog/blog-s-3.png"  />
                            <div className="blog-sidebar__post__content">
                            <p className="blog-sidebar__post__date">
                                <i className="far fa-calendar-alt" />
                                November 25, 2022
                            </p>
                            <h4 className="blog-sidebar__post__title">
                                <Link to="/blogdetails">
                                {" "}
                                Newly Supporte Modern CSS Pseudo Class
                                </Link>
                            </h4>
                           
                            </div>
                           
                        </li>
                        <li>
                            <img src="assets/images/blog/blog-s-4.png"  />
                            <div className="blog-sidebar__post__content">
                            <p className="blog-sidebar__post__date">
                                <i className="far fa-calendar-alt" />
                                November 25, 2022
                            </p>
                            <h4 className="blog-sidebar__post__title">
                                <Link to="/blogdetails">
                                Podcast Episode 36 With Miriam Suzanne Future
                                </Link>
                            </h4>
                           
                            </div>
                           
                        </li>
                        </ul>
                     
                    </div>
                   
                    <div className="blog-sidebar__widget blog-sidebar__widget--tags">
                        <h3 className="blog-sidebar__title">Popular Tags</h3>
                       
                        <p className="blog-sidebar__tags">
                        <Link to="#">
                            <span>Insurance</span>
                        </Link>
                        <Link to="#">
                            <span>House</span>
                        </Link>
                        <Link to="#">
                            <span>Medical</span>
                        </Link>
                        <Link to="#">
                            <span>Banking</span>
                        </Link>
                        <Link to="#">
                            <span>Car Insurance</span>
                        </Link>
                        <Link to="#">
                            <span>Fire</span>
                        </Link>
                        <Link to="#">
                            <span>Study</span>
                        </Link>
                        <Link to="#">
                            <span>Business</span>
                        </Link>
                        </p>
                       
                    </div>
                   
                    </div>
                    
                </div>
                
                </div>
               
            </div>
        </div>

    </>
  )
}

export default Risetwo